import { StatsContexterService } from 'pf-frontend-common/src/service/stats-contexter/service';
import { WindowLocationService } from 'pf-frontend-common/src/service/window-location/service';

import { AutocompleteTemplate } from 'common/module/autocomplete/template';
import { BrokerAutocompleteStoreFactory } from 'common/module/broker/autocomplete/store.factory';
import { BrokerSerpStore } from 'common/module/broker-serp/store';
import { LoaderViewDynamicFactory } from 'common/module/loader/view-dynamic.factory';
import { PreactView } from 'common/module/preact/view';
import { StatsService } from 'common/service/stats/service';
import { AutocompleteViewStoreFactory } from 'desktop/module/autocomplete/view-store.factory';
import { BrokerListTemplate } from 'desktop/module/broker/list/template';
import { BrokerListViewStoreFactory } from 'desktop/module/broker/list/view-store.factory';

import { BrokerHomeView } from './view';

export function BrokerHomeViewFactory(brokerSerpStore: BrokerSerpStore): BrokerHomeView {
  return new BrokerHomeView(
    WindowLocationService(),
    new PreactView(AutocompleteTemplate, AutocompleteViewStoreFactory()),
    LoaderViewDynamicFactory(),
    new PreactView(BrokerListTemplate, BrokerListViewStoreFactory(brokerSerpStore)),
    BrokerAutocompleteStoreFactory(),
    StatsContexterService(),
    StatsService()
  );
}
